import { path } from "ramda";
import React, { Component } from "react";
import { connect } from "react-redux";
import { startActivity } from "../../api/checkIn";
import { fetchWorker } from "../../api/employees";
import Breadcrumbs from "../../common/Breadcrumbs";

class ConfirmCheckIn extends Component {
    constructor(props) {
        super(props);

        this.handleConfirm = this.handleConfirm.bind(this);
    }

    componentDidMount() {
        const { userid } = this.props.location.state;
        this.props.loadWorker(userid);
    }

    handleConfirm() {
        const state = this.props.location.state || {};
        const { userid } = state;
        const task_id = path(['task', 'task_id'], state);
        const activity_id = path(['activity', 'id'], state);

        const formData = new FormData();
        formData.append('user_id', userid);
        formData.append('task_id', task_id);
        formData.append('type_id', activity_id);
        this.props.initActivity(formData);
    }

    render() {
        const state = this.props.location.state || {};

        const { userid } = state;

        const worker = path(['employees', 'worker'], this.props);
        const workerFullname = worker ? `${worker.firstname} ${worker.lastname}` : '';

        const task_name = path(['task', 'task_name'], state);
        const task_description = path(['task', 'description'], state);
        const activity_name = path(['activity', 'label'], state);

        return (
            <div>
                <Breadcrumbs
                    list={[
                        { url: '/pages/check-in', icon: 'perm_contact_calendar', name: 'Check In' },
                        { url: '/pages/check-in', icon: 'person', name: `${workerFullname}` },
                        { url: '/pages/check-in', icon: 'assignment', name: 'New Work' },
                    ]}
                />
                <div className="card">
                    <div className="card-header rounded-top">Confirm</div>
                    <div className="card-block">
                        <div className="d-flex justify-content-end align-items-center">
                            <div>
                                <button
                                    className="btn btn-rounded btn-icon ui-btn pull-right m-l-10"
                                    onClick={() => this.props.history.push(`/pages/check-in/${userid}`)}
                                >Cancel</button>
                                <button
                                    className="btn btn-rounded btn-icon ui-btn pull-right"
                                    onClick={() => this.props.history.goBack()}
                                >Back</button>
                            </div>
                        </div>
                        <br />
                        <div>
                            <p>{`Customer: ${state.customer}`}</p>
                            <p>{`Work Order: ${task_name}`}</p>
                            <p>{`Description:`} <div>{task_description}</div></p>
                            <p>{`Activity: ${activity_name.toUpperCase()}`}</p>
                        </div>
                        <div className="btn btn-success ui-btn text-uppercase" onClick={this.handleConfirm}>Start Work</div>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        initActivity: (formData) => {
            startActivity(formData)(dispatch);
        },
        loadWorker: (workerId) => {
            fetchWorker(workerId)(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmCheckIn);



// WEBPACK FOOTER //
// ./src/containers/ConfirmCheckIn/index.js